import { render, staticRenderFns } from "./PriceSearch.vue?vue&type=template&id=1b1f44c8&scoped=true&"
import script from "./PriceSearch.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PriceSearch.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PriceSearch.vue?vue&type=style&index=0&id=1b1f44c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1f44c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b1f44c8')) {
      api.createRecord('1b1f44c8', component.options)
    } else {
      api.reload('1b1f44c8', component.options)
    }
    module.hot.accept("./PriceSearch.vue?vue&type=template&id=1b1f44c8&scoped=true&", function () {
      api.rerender('1b1f44c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/components/PriceToolbar/PriceSearch.vue"
export default component.exports